export { CompactPagination } from './CompactPagination';
